import { render, staticRenderFns } from "./noticeDetailList.vue?vue&type=template&id=682d3898&scoped=true"
import script from "./noticeDetailList.vue?vue&type=script&lang=js"
export * from "./noticeDetailList.vue?vue&type=script&lang=js"
import style0 from "./noticeDetailList.vue?vue&type=style&index=0&id=682d3898&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682d3898",
  null
  
)

export default component.exports